module.exports = __webpack_public_path__ + "img/1010.f0dcfd0f.gif";